import React from 'react';
import { useTranslation } from 'react-i18next';

import projectsApi from 'api/projects';
import translations from 'services/translations/translations';
import SearchDropdown from './SearchDropdown';

const ProjectSelect = ({
  label,
  onChange,
  value,
}: {
  label?: string;
  onChange: (e: any) => void;
  value: any;
}): JSX.Element => {
  const { t } = useTranslation([translations.common]);

  const loadOptions = async (search: string) => {
    const projects = await projectsApi.getAll({ limit: 50, offset: 0, search });
    return projects.map((project: any) => ({
      label: project.name,
      value: project.id,
    }));
  };

  return (
    <SearchDropdown
      label={label}
      loadOptions={loadOptions}
      onChange={onChange}
      placeholder={t(`${translations.common}:Search`)}
      value={value}
    />
  );
};

export default ProjectSelect;
